import { io } from "socket.io-client"
import { getSocketsUrl } from "utils/getSocketsUrl"
import { TAGS, api } from "../../api"

export const happyHourAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.HAPPY_HOUR]
})

export const happyHourEndpoints = happyHourAPI.injectEndpoints({
  endpoints: (builder) => ({
    getHappyHour: builder.query<IHappyHour, void>({
      query: () => ({
        url: "/happy-hour/is-happy-hour",
        method: "GET"
      }),
      providesTags: [{ type: TAGS.HAPPY_HOUR, id: "HAPPY_HOUR" }],
      async onCacheEntryAdded(_, { updateCachedData, cacheDataLoaded }) {
        const happyHourSocket = io(`${getSocketsUrl()}/happy_hour`, {
          transports: ["websocket"]
        })
        await cacheDataLoaded

        const listener = (event: string) => {
          const data = JSON.parse(event)
          updateCachedData((draft) => {
            Object.assign(draft, data)
          })
        }

        happyHourSocket.on("happy_hour:get_status", listener)
      }
    })
  })
})
